import { eachDayOfInterval, format, isWeekend } from 'date-fns';
import { DateRange } from 'shared/types/date-range';

export type TimelineWeekendBand = {
  key: string;
  left: number;
  width: number;
};

export type GetTimelineWeekendBandsOptions = {
  dateRange: DateRange;
  dayWidth: number;
};

type DayIndexBand = {
  key: string;
  startIndex: number;
  dayCount: number;
};

export const getTimelineWeekendBands = ({
  dateRange,
  dayWidth,
}: GetTimelineWeekendBandsOptions): TimelineWeekendBand[] => {
  if (dayWidth <= 0) {
    return [];
  }

  const days = eachDayOfInterval({
    start: dateRange.startDate,
    end: dateRange.endDate,
  });

  return days
    .reduce<DayIndexBand[]>((bands, day, index) => {
      if (!isWeekend(day)) {
        return bands;
      }
      const last = bands[bands.length - 1];
      if (last && last.startIndex + last.dayCount === index) {
        last.dayCount += 1;
        return bands;
      }
      bands.push({
        key: format(day, 'yyyy-MM-dd'),
        startIndex: index,
        dayCount: 1,
      });
      return bands;
    }, [])
    .map(({ key, startIndex, dayCount }) => ({
      key,
      left: startIndex * dayWidth,
      width: dayCount * dayWidth,
    }));
};
